import { History } from "lucide-react";
import { brl, dateBR } from "../lib/format";
import { Card, Empty } from "./common";

const FIELDS = [["value", "Valor", (v) => brl(v, 2)], ["discount", "Desconto", (v) => brl(v, 2)], ["start", "Vigência", dateBR], ["status", "Status", (v) => v], ["end", "Fim", dateBR]];
const ACTION = { inclusao: ["Inclusão", "bg-emerald-50 text-emerald-700"], atualizacao: ["Atualização", "bg-sky-50 text-sky-700"], alteracao: ["Alteração", "bg-sky-50 text-sky-700"], exclusao: ["Exclusão", "bg-rose-50 text-rose-700"] };

export const BenefitDelta = ({ h }) => {
  if (!h.after) return <div className="text-xs text-slate-400 mt-0.5">Valores restritos</div>;
  const rows = FIELDS.filter(([k]) => k in h.after);
  return (
    <div className="text-xs text-slate-600 mt-1 flex flex-wrap gap-x-4 gap-y-0.5">
      {rows.map(([k, l, f]) => <span key={k}>{l}: {h.before?.[k] != null && <span className="font-mono text-slate-400 line-through mr-1">{f(h.before[k])}</span>}<span className="font-mono font-medium text-slate-900">{f(h.after[k])}</span></span>)}
    </div>);
};

export const BenefitTimeline = ({ items, onOpenRequest }) => (
  <Card className="p-6" testid="benefit-timeline">
    <div className="text-sm font-semibold mb-4 flex items-center gap-1.5"><History className="h-4 w-4" />Histórico de benefícios</div>
    {items.length === 0 ? <Empty title="Nenhuma mudança registrada" hint="Inclusões, alterações e exclusões de benefícios aparecem aqui." /> : (
      <ol className="relative border-l border-slate-200 ml-2 space-y-5">
        {items.map((h) => {
          const [al, ac] = ACTION[h.action] || ["Mudança", "bg-slate-100 text-slate-600"];
          return (
            <li key={h.id} className="ml-6" data-testid={`benefit-hist-${h.id}`}>
              <span className="absolute -left-[5px] h-2.5 w-2.5 rounded-full bg-emerald-500 ring-4 ring-emerald-50" />
              <div className="flex flex-wrap items-center gap-2"><span className="font-mono text-xs text-slate-500">{dateBR(h.date)}</span>
                <span className={`text-[11px] font-semibold rounded-full px-2 py-0.5 ${ac}`}>{al}</span><span className="text-sm font-medium">{h.benefit}</span></div>
              <BenefitDelta h={h} />
              <div className="text-[11px] text-slate-400 mt-1">por {h.by}{h.protocol && <> · <button type="button" onClick={() => onOpenRequest(h.request_id)} className="font-mono text-indigo-700 hover:underline" data-testid={`benefit-hist-protocol-${h.id}`}>demanda #{h.protocol}</button></>}</div>
            </li>);
        })}
      </ol>)}
  </Card>
);
